import {
  createBrowserRouter,
  RouterProvider,
} from "react-router";

import React from "react";
import { createRoot } from "react-dom/client";

import SystemOneApp from "common/SystemOneApp";

import { companyRoute } from "pages/company/routes";
import { contactRoute } from "pages/contact/routes";
import { contentRoute } from "pages/content/routes";
import { contractRoute } from "pages/contract/routes";
import { costCenterRoute } from "pages/costcenter/routes";
import { creditTransactionRoute } from "pages/credittransaction/routes";
import { countryRoute } from "pages/country/routes";
import { cultureRoute } from "pages/culture/routes";
import { defaultTaskRoute } from "pages/defaultTask/routes";
import { excelTemplateRoute } from "pages/exceltemplate/routes";
import { exchangeRateRoute } from "pages/exchangerate/routes";
import { externalCalendarRoute } from "pages/externalcalendar/routes";
import { externalIdentityRoute } from "pages/externalidentity/routes";
import { extractorSessionRoute } from "pages/extractorsession/routes";
import { fileRoute } from "pages/file/routes";
import { flightRoute } from "pages/flight/routes";
import { freeFieldCategoryRoute } from "pages/freefieldcategory/routes";
import { freeFieldDetailRoute } from "pages/freefielddetails/routes";
import { freeFieldProfileRoute } from "pages/freefieldprofile/routes";
import { groundTransportRoute } from "pages/groundtransport/routes";
import { iCalRoute } from "pages/ical/routes";
import { iCalendarTemplateRoute } from "pages/icalendartemplate/routes";
import { invoiceRoute } from "pages/invoice/routes";
import { invoiceExportRoute } from "pages/invoiceexport/routes";
import { mergefieldsRoute } from "pages/mergefields/routes";
import { messageTemplateRoute } from "pages/messagetemplate/routes";
import { notificationRoute } from "pages/notification/routes";
import { invoiceV2Route } from "pages/invoiceV2/routes";
import { paymentRoute } from "pages/payment/routes";
import { personalSettingsRoute } from "pages/personalsettings/routes";
import { planningRoute } from "pages/planning/routes";
import { productGroupRoute } from "pages/productgroup/routes";
import { productionRoute } from "pages/production/routes";
import { productTemplateRoute } from "pages/producttemplate/routes";
import { promoterRoute } from "pages/promoter/routes";
import { purchaseAgreementRoute } from "pages/purchaseagreement/routes";
import { quoteRoute } from "pages/quote/routes";
import { showRoute } from "pages/show/routes";
import { stateAliasRoute } from "pages/stateAlias/routes";
import { statusRoute } from "pages/status/routes";
import { systemSettingsRoute } from "pages/systemsettings/routes";
import { tagRoute } from "pages/tag/routes";
import { templateSettingsRoute } from "pages/templatesettings/routes";
import { trainRoute } from "pages/train/routes";
import { userRoute } from "pages/user/routes";
import { userActionRoute } from "pages/useraction/routes";
import { userForAdminOneRoute } from "pages/userforadminone/routes";
import { venueRoute } from "pages/venue/routes";
import { webformRoute } from "pages/webform/routes";
import { wordTemplateRoute } from "pages/wordtemplate/routes";
import { wordTemplateForListViewRoute } from "pages/wordtemplateforlistview/routes";
import { clientRoute } from "pages/client/routes";
import { checklistPresetRoute } from "pages/checklistpreset/routes";
import { bankAccountRoute } from "pages/bankaccount/routes";
import { bookkeepingRoute } from "pages/bookkeeping/routes";
import { brandRoute } from "pages/brand/routes";
import { businessCentralProjectRoute } from "pages/businesscentralproject/routes";
import { artistRiderRoute } from "pages/artistrider/routes";
import { artistRoute } from "pages/artist/routes";
import { articleRoute } from "pages/article/routes";
import { articleCategoryRoute } from "pages/articlecategory/routes";
import { airportRoute } from "pages/airport/routes";
import { advancingTemplateRoute } from "pages/advancingtemplate/routes";
import { accountRoute } from "pages/account/routes";
import { esignRoute } from "pages/esign/routes";
import { clientOnboardingRoute } from "pages/clientonboarding/routes";
import { advancingRoute } from "pages/advancing/routes";
import { downloadRoute, homeRoute } from "pages/home/routes";
import { taskManagerRoute } from "pages/taskmanager/routes";
import { ErrorBoundary } from "pages/ErrorBoundary";
import { externalEventRoute } from "pages/externalevent/routes";
import { wizardEmbedShowRoute } from "pages/wizard/routes";
import { subscriptionRoute } from "pages/subscription/routes";
import SystemOneLoginApp from "common/SystemOneLoginApp";

const router = createBrowserRouter([{
  path: "/account",
  Component: SystemOneLoginApp,
  ErrorBoundary,
  children: [
    accountRoute,
  ]
}, {
  path: "/externalidentity",
  Component: SystemOneLoginApp,
  ErrorBoundary,
  children: [
    externalIdentityRoute,
  ]
}, {
  path: "/",
  Component: SystemOneApp,
  ErrorBoundary,
  children: [
    advancingRoute,
    advancingTemplateRoute,
    airportRoute,
    articleRoute,
    articleCategoryRoute,
    artistRoute,
    artistRiderRoute,
    bankAccountRoute,
    bookkeepingRoute,
    brandRoute,
    businessCentralProjectRoute,
    checklistPresetRoute,
    clientRoute,
    clientOnboardingRoute,
    companyRoute,
    contactRoute,
    contentRoute,
    contractRoute,
    costCenterRoute,
    creditTransactionRoute,
    countryRoute,
    cultureRoute,
    defaultTaskRoute,
    downloadRoute,
    esignRoute,
    excelTemplateRoute,
    exchangeRateRoute,
    externalCalendarRoute,
    externalEventRoute,
    externalIdentityRoute,
    extractorSessionRoute,
    fileRoute,
    flightRoute,
    freeFieldCategoryRoute,
    freeFieldDetailRoute,
    freeFieldProfileRoute,
    groundTransportRoute,
    homeRoute,
    iCalRoute,
    iCalendarTemplateRoute,
    invoiceRoute,
    invoiceExportRoute,
    mergefieldsRoute,
    messageTemplateRoute,
    notificationRoute,
    invoiceV2Route,
    paymentRoute,
    personalSettingsRoute,
    planningRoute,
    productGroupRoute,
    productionRoute,
    productTemplateRoute,
    promoterRoute,
    purchaseAgreementRoute,
    quoteRoute,
    showRoute,
    stateAliasRoute,
    statusRoute,
    subscriptionRoute,
    systemSettingsRoute,
    tagRoute,
    taskManagerRoute,
    templateSettingsRoute,
    trainRoute,
    userRoute,
    userActionRoute,
    userForAdminOneRoute,
    venueRoute,
    webformRoute,
    wizardEmbedShowRoute,
    wordTemplateRoute,
    wordTemplateForListViewRoute
  ]
}]);

document.addEventListener("DOMContentLoaded", () => {
  const root = createRoot(document.getElementById("app"));
  root.render(
    <RouterProvider router={router} />
  );
});
